import { Component, Input } from '@angular/core'
import { ListingQuery } from '../../../../../../graphql'

@Component({
    selector: 'app-listing-heading',
    templateUrl: 'listing-heading.html'
})
export class ListingHeadingComponent {
    @Input() listing: ListingQuery['listing']
}
